import { array, object, string } from "yup";

export const mailFormSchema = object({
  templateType: string().optional(),
  recipients: array(object({ name: string(), firstname: string(), mail: string().email("L'email est invalide.") }))
    .min(1, "Un destinataire est obligatoire.")
    .required(),
  cc: array(string().email("L'email est invalide.")).optional(),
  subject: string().required("Un objet est requis."),
  attachments: array(object({ _id: string().required() })).required(),
  content: object({
    text: string().default(""),
    html: string().required("Le contenu de l'email ne peut être vide."),
  }).required(),
});
